import React from 'react';
import { ArrowRightIcon } from '@fiverr-private/visuals';
import { Container, LinkCard } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { getContext } from '@fiverr-private/fiverr_context';
import { assignInlineVars } from '@fiverr-private/theme';
import { reportNavigationCardClickEvent } from '../../../utils/reportBiEvent/reportNavigationCardClickEvent';
import { theme } from '../../../theme';
import { appTranslate } from '../../../i18n';
import { Button } from '../../buttons';
import { ModelGradient } from '../../gradients';
import { NavigationCardProps } from './NavigationCard.types';
import { CARD_CONFIGS } from './NavigationCard.config';

import * as styles from './NavigationCard.ve.css';

export const NavigationCard = ({
    title,
    modelGradientProps,
    buttonProps,
    cardSize = 'sm',
    url = '',
    cardBackground = theme.colors.grey1250,
    biEventData,
    shouldShowButton = false,
}: NavigationCardProps) => {
    const {
        size,
        titleHeight,
        borderRadius,
        titleFontSize,
        titleFontWeight,
        titleLineHeight,
        titleLineClamp,
        gradientBorderRadius,
    } = CARD_CONFIGS[cardSize];

    const { isMobile = false } = getContext();
    const displayMode = isMobile ? 'flex' : 'none';

    const handleButtonClick = () => {
        if (biEventData) {
            reportNavigationCardClickEvent(biEventData);
        }

        if (url) {
            window.location.href = url;
        }
    };

    return (
        <LinkCard
            className={styles.container}
            display="flex"
            direction="column"
            background={cardBackground}
            borderRadius={borderRadius}
            height={size.height}
            width={size.width}
            gap="3"
            onClick={handleButtonClick}
        >
            <Container position="relative" width="100%" height="100%" borderRadius="md" flex="1" overflow="hidden">
                <ModelGradient {...modelGradientProps} borderRadius={gradientBorderRadius} />
                {shouldShowButton && (
                    <Button
                        className={styles.button}
                        style={assignInlineVars({
                            [styles.displayMode]: displayMode,
                        })}
                        {...buttonProps}
                    >
                        {buttonProps?.text || appTranslate<string>('navigation_card.start_generating')}
                        {buttonProps?.showIcon && <ArrowRightIcon />}
                    </Button>
                )}
            </Container>
            {title && (
                <Typography
                    title={title}
                    height={titleHeight}
                    fontSize={titleFontSize}
                    fontWeight={titleFontWeight}
                    lineHeight={titleLineHeight}
                    color="white"
                    display="webkitBox"
                    textOverflow="ellipsis"
                    overflow="hidden"
                    webkitLineClamp={titleLineClamp}
                    webkitBoxOrient="vertical"
                >
                    {title}
                </Typography>
            )}
        </LinkCard>
    );
};

NavigationCard.displayName = 'NavigationCard';
